import { useQuery } from "@tanstack/react-query";

import { getActorsActorIDPriceCategories } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { ACTORS_QUERY_KEYS } from "./queryKeys";

export function useActorPriceCategoriesQuery(actorID: string | undefined) {
  return useQuery({
    queryKey: ACTORS_QUERY_KEYS.priceCategories(actorID!),
    queryFn: processResponse(() => getActorsActorIDPriceCategories(actorID!)),
    enabled: !!actorID,
  });
}
